module.exports = __webpack_public_path__ + "img/3dmodel_active.386e7bec.svg";